module.exports = __webpack_public_path__ + "static/media/pw.f67a3db4.svg";